import { get, post, put } from "shared/data";

const baseEndpoint = "/coding/attribute-feedback";

const buildTaskEndpoint = (taskKey) => `${baseEndpoint}?taskKey=${taskKey}`;

export const getAttributeFeedback = (taskKey) => {
    return get(buildTaskEndpoint(taskKey), { defaultReturn: [] });
};

export const createAttributeFeedback = (taskKey, payload) => {
    return post(buildTaskEndpoint(taskKey), payload);
};

// The record is identified by its route param, 'taskKey' is not part of the edit call.
export const updateAttributeFeedback = (id, payload) => {
    return put(`${baseEndpoint}/${id}`, payload);
};
